module.exports = __webpack_public_path__ + "static/vial-horizontal.a9480f96.png";


//////////////////
// WEBPACK FOOTER
// ./assets/vial-horizontal.png
// module id = ./assets/vial-horizontal.png
// module chunks = 63538265317374 137408898365125 269238729700051